import { render, staticRenderFns } from "./AddPurchaseCosting.vue?vue&type=template&id=75e04a1b&"
import script from "./AddPurchaseCosting.vue?vue&type=script&lang=js&"
export * from "./AddPurchaseCosting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports